import ToJSX, { MarkdownToJSX } from 'markdown-to-jsx';
import { Body, Divider, Image, SimpleList, Stack, Title, Typography } from '@optimus-web/core';
import NewWindowLink from './NewWindowLink';

export type MarkdownOptions = Pick<MarkdownToJSX.Options, 'overrides' | 'wrapper'>;

const MarkdownWrapper: React.FC<React.PropsWithChildren<{}>> = ({ children }) => (
    <Stack spacing="200" vertical>
        {children}
    </Stack>
);

const defaultOptions: MarkdownToJSX.Options = {
    disableParsingRawHTML: true,
    wrapper: MarkdownWrapper,
    overrides: {
        h1: {
            component: (props) => <Title level={1} {...props} />,
        },
        h2: {
            component: (props) => <Title level={2} {...props} />,
        },
        h3: {
            component: (props) => <Title level={3} {...props} />,
        },
        h4: {
            component: (props) => <Typography textStyle="titleSmall" variant="secondary" {...props} />,
        },
        h5: {
            component: Body,
        },
        h6: {
            component: Body,
        },
        p: {
            component: Body,
        },
        hr: {
            component: Divider,
        },
        a: {
            component: (props) => <NewWindowLink wordBreak="break-word" {...props} />,
        },
        img: {
            component: Image,
        },
        ul: {
            component: SimpleList,
        },
        ol: {
            component: (props) => <SimpleList ordered {...props} />,
        },
    },
};

const mergeOptions = (options: MarkdownOptions) => ({
    ...defaultOptions,
    ...options,
    overrides: { ...defaultOptions.overrides, ...options.overrides },
});
interface MarkdownProps {
    content: string;
    options?: MarkdownOptions;
}

export const Markdown: React.FC<MarkdownProps> = ({ content, options }) => (
    <ToJSX options={options ? mergeOptions(options) : defaultOptions}>{content}</ToJSX>
);
